import React from 'react'

function RefreshButton() {
  return (
    <div>
        <div className=' center'
            style={{
              // background:"red",
              width:"40px",
              height:"40px",
              paddingTop:"9px",
              cursor:"pointer"
            }}
            onClick={()=>window.location.reload()}
        >
            <i className='material-icons black-text center'>refresh</i>
        </div>
    </div>
  )
}

export default RefreshButton